import { ReactComponent as Preferences } from "../assets/icons/my-profile/preferences.svg";
import genIcons from "./genIcons";

const PreferencesIcon = { Outline: genIcons(Preferences, { style: { margin: "auto 0", }})};

export default PreferencesIcon;
